import { render, staticRenderFns } from "./Sensor.vue?vue&type=template&id=2ff1d1f9&scoped=true"
import script from "./Sensor.vue?vue&type=script&lang=js"
export * from "./Sensor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff1d1f9",
  null
  
)

export default component.exports